import { RouteLocationNormalizedLoaded } from 'vue-router'
import { IBreadcrumbDataFromListing } from '@/types/data-objects/global'
import { IBreadcrumbItemMenuItem } from '@/types/data-objects/items'
import { useAppStore } from '@/modules/app/app.store'
import RouteAssistant from '@/helpers/route-assistant'

export default new class BreadcrumbAssistant {
  public fromAll(route: RouteLocationNormalizedLoaded): boolean {
    return RouteAssistant.routeState(route, 'from_all')
  }

  public fromEntityLanding(route: RouteLocationNormalizedLoaded): boolean {
    return (
      (RouteAssistant.routeState(route, 'from_entity_home') ||
        RouteAssistant.routeState(route, 'from_kanban_board')) &&
      this.lastVisitedBreadcrumbDataFromListing() !== null
    )
  }

  public lastVisitedBreadcrumbDataFromListing(): IBreadcrumbDataFromListing {
    return useAppStore().lastVisitedBreadcrumbDataFromListing
  }

  public lastVisitedBreadcrumbItemMenuItems() {
    return useAppStore().lastVisitedBreadcrumbItemMenuItems
  }

  public cacheBreadcrumbDataFromListing(data: IBreadcrumbDataFromListing) {
    useAppStore().lastVisitedBreadcrumbDataFromListing = data
  }

  public cacheBreadcrumbItemMenuItems(data: IBreadcrumbItemMenuItem[]) {
    useAppStore().lastVisitedBreadcrumbItemMenuItems = data
  }

  public getPreviousBreadcrumbItem(
    curRefNumber: number,
  ): IBreadcrumbItemMenuItem {
    const breadcrumbItems = this.lastVisitedBreadcrumbItemMenuItems()

    if (breadcrumbItems === null) {
      return null
    }

    const curIndex = breadcrumbItems.findIndex(
      i => i.refNumber === curRefNumber,
    )

    if (curIndex > 0) {
      return breadcrumbItems[curIndex - 1]
    }

    return null
  }

  public getNextBreadcrumbItem(
    curRefNumber: number,
  ): IBreadcrumbItemMenuItem {
    const breadcrumbItems = this.lastVisitedBreadcrumbItemMenuItems()

    if (breadcrumbItems === null) {
      return null
    }

    const curIndex = breadcrumbItems.findIndex(
      i => i.refNumber === curRefNumber,
    )

    if (curIndex >= 0 && curIndex < breadcrumbItems.length - 1) {
      return breadcrumbItems[curIndex + 1]
    }

    return null
  }
}()
